// Court-map images (F6). Hardcoded/bundled for now — see SCOPE_AND_QUOTATION.md.
// Config-driven so the display layer never hardcodes a path: today every court
// type resolves to the single venue-wide map; to make a type-specific map later,
// add an entry keyed by the court type's (lowercased) name. To move to dynamic
// admin uploads, this resolver is the only thing that changes (return a Storage URL).

// `?v=` cache-buster — bump this whenever the map image is replaced so returning
// customers' browsers fetch the new one instead of a stale cached copy.
const VENUE_MAP = '/courtTypes/maps/court-map-345.jpg?v=4';

// Optional per-court-type overrides, keyed by lowercased court type name.
const COURT_MAPS = {
  // football: '/courtTypes/maps/football-map.jpg',
  // badminton: '/courtTypes/maps/badminton-map.jpg',
};

/**
 * Resolve the court-map image for a given court type name.
 * @param {string} [courtTypeName]
 * @returns {string} public path to the map image
 */
export function getCourtMap(courtTypeName) {
  const key = (courtTypeName || '').trim().toLowerCase();
  return COURT_MAPS[key] || VENUE_MAP;
}
